import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { AllocationService } from 'src/app/_services/resource-allocation/allocation.service';
import { DatePipe } from '@angular/common';
import { UserService } from 'src/app/_services/user/user.service';
import { LocalStorageService } from 'src/app/_services/localStorage/local-storage.service'

@Component({
  selector: 'app-onboarding-it',
  templateUrl: './onboarding-it.component.html',
  styleUrls: ['./onboarding-it.component.scss']
})
export class OnboardingItComponent implements OnInit {
  tenantId: string;
  usersForm;
  userCreationForm;
  userDropdownList = [];
  getUserName: any;
  isHRAdmin: boolean;
  isITAdmin: boolean;
  userDetails: any;
  requester: any;
  TodayDate: string;
  date: any;
  userCreationId: any;
  userFullName: any;
  license: boolean;
  usersData: any = [];
  usersCreationData: any = [];
  systemRequiredBooleanValue: any;
  // public licenseTypeList:  Array<any> = [];

  constructor(
    private router: Router,
    private storageService: LocalStorageService,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private allocationService: AllocationService,
    private userService: UserService,
    private datePipe: DatePipe,
    private snackBar: MatSnackBar
  ) {
    this.usersForm = this.formBuilder.group({
      id: new FormControl(''),
      userId: new FormControl(''),
      password: new FormControl(''),
      firstName: new FormControl(''),
      lastName: new FormControl(''),
      displayName: new FormControl(''),
      department: new FormControl(''),
      phoneNo: new FormControl(''),
      location: new FormControl(''),
      joinDate: new FormControl(''),
      permanentOrContractor: new FormControl(''),
      alternateEmailId: new FormControl(''),
      supervisorId: new FormControl(''),
      supervisonName: new FormControl(''),
      currentDesignation: new FormControl(''),
      careerStartDate: new FormControl(''),
      middleName: new FormControl(''),
      managerId: new FormControl(''),
      managerName: new FormControl(''),
      addedToBioMetrics: new FormControl(''),
      totalExperience: new FormControl(''),
      currentExperience: new FormControl(''),
      birthDate: new FormControl(''),
    });
    this.userCreationForm = this.formBuilder.group({
      id: new FormControl(''),
      requesterId: new FormControl({value:'' , disabled: true}),
      requesterName: new FormControl({value:'' , disabled: true}),
      requestedDate: new FormControl({value:'' , disabled: true}),
      localId: new FormControl({value: '', disabled: true}),
      status: new FormControl({value:'', disabled: true}),
      userId: new FormControl({value: '', disabled: true}),
      firstName: new FormControl(''),
      middleName: new FormControl(''),
      lastName: new FormControl(''),
      // emailId: new FormControl('', Validators.required),
      emailId: new FormControl(''),
      remarks: new FormControl(''),
      addedToBioMetrics: new FormControl(''),
      licenseType: new FormControl(''),
      licenseRequired: new FormControl(''),
      licenseAllocation: new FormControl(''),
      systemRequiredBoolean: new FormControl(''),
      systemRequired: new FormControl(''),
      ndaSignedDate: new FormControl({value:'' , disabled: true}),
      biometric: new FormControl(''),
      // ismsTraining: new FormControl('', Validators.required),
      // ismsAgreement: new FormControl('', Validators.required),
      // passwordBoolean: new FormControl('', Validators.required),
      ismsTraining: new FormControl(''),
      ismsAgreement: new FormControl(''),
      passwordBoolean: new FormControl(''),
      emailIdRequired: new FormControl({value:''}),
      ndaSignedBoolean: new FormControl({value:''}),
      domainUserId: new FormControl({value:''})
    });
  }

  ngOnInit(): void {
    this.tenantId = this.storageService.get('tenantId');
    this.userDetails = JSON.parse(this.storageService.get('currentUser'));
    // this.licenseTypeList = [
    //   { id: 1, licenseTypeName: "Enterprise Mobility + Security E3" },
    //   { id: 2, licenseTypeName: "Microsoft 365 Business Basic" },
    //   { id: 3, licenseTypeName: "Microsoft 365 Business Standard" }
    // ]

    this.requester = this.userDetails.id + " . " + this.userDetails.firstName + " " + this.userDetails.lastName;
    this.date = new Date();
    let latest_date = this.datePipe.transform(this.date, 'yyyy-MM-dd');
    this.TodayDate = latest_date;

    this.userCreationForm.value.requesterId = this.requester;
    this.userCreationForm.value.requestedDate = this.TodayDate;
    this.userCreationForm.patchValue(this.userCreationForm.value);

    this.isHRAdmin = this.userDetails.admin || this.userDetails.roles.includes('RoleHrmAdministrator') ;
    this.isITAdmin = this.userDetails.admin || this.userDetails.roles.includes('RoleITAdministrator') ;

    this.userCreationId = this.route.snapshot.paramMap.get('id');
    if (this.userCreationId) {
      this.getUserCreationById(this.userCreationId);
    }
  }

  checkOnboardingStatus(){
    const userEmailId = this.userCreationForm.get('emailId');
    const userISMSTraining = this.userCreationForm.get('ismsTraining');
    const userISMSAgreement = this.userCreationForm.get('ismsAgreement');
    const userPasswordBoolean = this.userCreationForm.get('passwordBoolean');
    const userDomainUserId = this.userCreationForm.get('domainUserId');
    const userBiometric = this.userCreationForm.get('biometric');

    if(this.usersCreationData.status === 'withItTeam'){
      userEmailId?.setValidators([Validators.required]);
      userISMSAgreement?.setValidators([Validators.required]);
      userISMSTraining?.setValidators([Validators.required]);
      userPasswordBoolean?.setValidators([Validators.required]);

      userEmailId?.enable();
      userISMSAgreement?.enable();
      userISMSTraining?.enable();
      userPasswordBoolean?.enable();
    }
    else{
      userEmailId?.disable();
      userISMSAgreement?.disable();
      userISMSTraining?.disable();
      userPasswordBoolean?.disable();
      userDomainUserId?.disable();
      userBiometric?.disable();


      userDomainUserId?.updateValueAndValidity();
      userBiometric?.updateValueAndValidity();
    }
    userEmailId?.updateValueAndValidity();
    userISMSAgreement?.updateValueAndValidity();
    userISMSTraining?.updateValueAndValidity();
    userPasswordBoolean?.updateValueAndValidity();
  }

  getUserCreationById(id){
    this.userService.getUserCreationById(id).subscribe((response) => {
      this.usersCreationData = response;
      this.checkOnboardingStatus();
      if (response) {
        this.userCreationForm.patchValue({
          requesterId: response.requesterId + " . " + response.requesterName,
          requestedDate: response.requestedDate,
          userId: response.userId + " . " + response.firstName + " " + response.lastName,
          status: response.status,
          remarks: response.remarks,
          biometric: response.biometric,
          licenseType: response.licenseType,
          licenseRequired: response.licenseRequired,
          ismsTraining: response.ismsTraining,
          passwordBoolean: response.passwordBoolean,
          ismsAgreement: response.ismsAgreement,
          licenseAllocation: response.licenseAllocation,
          domainUserId: response.domainUserId,
        })
      }

      if(response.licenseRequired === true){
        this.license = true;
      }

      this.systemRequiredBooleanValue = response.systemRequiredBoolean;
      let systemRequiredValue = response.systemRequired;
      let userId = response.userId;
      this.userService.getUser(userId).subscribe((response) => {
        this.userFullName = response.firstName + " "+ response.middleName + " " + response.lastName;
        this.usersData = response;
        this.usersForm.patchValue({
          userId: response.userId,
          localId: response.localId,
          password: response.password,
          firstName: response.firstName,
          middleName: response.middleName,
          lastName: response.lastName,
          displayName: response.displayName,
          department: response.department,
          alternateEmailId: response.alternateEmailId,
          phoneNo: response.phoneNo,
          location: response.location,
          joinDate: response.joinDate,
          permanentOrContractor: response.permanentOrContractor,
          supervisonName: response.supervisorId + ' . ' + response.supervisonName,
          currentDesignation: response.currentDesignation,
          archived: true,
          managerName: response.managerName,
          birthDate: response.birthDate,
        });
        this.userCreationForm.value.emailId = response.emailId;
        this.userCreationForm.value.localId = response.localId;
        this.userCreationForm.patchValue(this.userCreationForm.value);
      })
    })
  }

  updateUserCreation(){
    let userId = this.userCreationForm.get('userId').value.split(' . ')[0];
    let user = {
      id: parseInt(userId),
      userId: this.usersData.userId,
      localId: this.usersData.localId,
      firstName: this.usersData.firstName,
      middleName: this.usersData.middleName,
      lastName: this.usersData.lastName,
      displayName: this.usersData.displayName,
      department: this.usersData.department,
      emailId: this.userCreationForm.get('emailId').value,
      alternateEmailId: this.usersData.alternateEmailId,
      phoneNo: this.usersData.phoneNo,
      location: this.usersData.location,
      joinDate: this.usersData.joinDate,
      permanentOrContractor: this.usersData.permanentOrContractor,
      supervisorId: this.usersData.supervisorId,
      supervisonName: this.usersData.supervisonName,
      currentDesignation: this.usersData.currentDesignation,
      archived: true,
      managerName: this.usersData.managerName,
      domainUserId: this.usersData.domainUserId,
      // roles: this.usersData.roles,
      hrId: this.usersData.hrId,
      hrName: this.usersData.hrName,
      birthDate: this.usersData.birthDate,
    }
    this.userService.updateUser(userId, user).subscribe((response)=>{
      let userCreationData = {
        id: parseInt(this.userCreationId),
        requesterId: this.usersCreationData.requesterId,
        requesterName: this.usersCreationData.requesterName,
        requestedDate: this.usersCreationData.requestedDate,
        firstName: this.usersCreationData.firstName,
        lastName: this.usersCreationData.lastName,
        userId: this.usersCreationData.userId,
        status: 'waitingForApproval',
        remarks: this.userCreationForm.get('remarks').value,
        licenseType: this.userCreationForm.get('licenseType').value, //Need to comment code after Suraj's Confirmation
        licenseRequired: this.userCreationForm.get('licenseRequired').value, //Need to comment code after Suraj's Confirmation
        licenseAllocation: this.userCreationForm.get('licenseAllocation').value, //Need to comment code after Suraj's Confirmation
        systemRequiredBoolean: this.usersCreationData.systemRequiredBoolean,
        systemRequired: this.usersCreationData.systemRequired,
        biometric: this.userCreationForm.get('biometric').value,
        ismsTraining: this.userCreationForm.get('ismsTraining').value,
        ismsAgreement: this.userCreationForm.get('ismsAgreement').value,
        passwordBoolean: this.userCreationForm.get('passwordBoolean').value,
        domainUserId: this.userCreationForm.get('domainUserId').value,
        ndaSignedBoolean: this.usersCreationData.ndaSignedBoolean,
        ndaSignedDate: this.usersCreationData.ndaSignedDate,
        emailIdRequired: this.usersCreationData.emailIdRequired,
      }
      if (response) {
        this.userService.updateUserCreation(this.userCreationId, userCreationData).subscribe((response) => {
          this.userService.emailLink(this.userCreationForm.get('emailId').value).subscribe((response2) => {
            this.backToOnboarding();
          })
          
        })
      }
    })
  }

  updateUserCreationforLicense(){
    let userId = this.userCreationForm.get('userId').value.split(' . ')[0];
    let user = {
      id: parseInt(userId),
      userId: this.usersData.userId,
      localId: this.usersData.localId,
      firstName: this.usersData.firstName,
      middleName: this.usersData.middleName,
      lastName: this.usersData.lastName,
      displayName: this.usersData.displayName,
      department: this.usersData.department,
      emailId: this.userCreationForm.get('emailId').value,
      alternateEmailId: this.usersData.alternateEmailId,
      phoneNo: this.usersData.phoneNo,
      location: this.usersData.location,
      joinDate: this.usersData.joinDate,
      permanentOrContractor: this.usersData.permanentOrContractor,
      supervisorId: this.usersData.supervisorId,
      supervisonName: this.usersData.supervisonName,
      currentDesignation: this.usersData.currentDesignation,
      archived: true,
      managerName: this.usersData.managerName,
      domainUserId: this.usersData.domainUserId,
      // roles: this.usersData.roles,
      hrId: this.usersData.hrId,
      hrName: this.usersData.hrName,
      birthDate: this.usersData.birthDate,
    }
    this.userService.updateUser(userId, user).subscribe((response)=>{
      let userCreationData = {
        id: parseInt(this.userCreationId),
        requesterId: this.usersCreationData.requesterId,
        requesterName: this.usersCreationData.requesterName,
        requestedDate: this.usersCreationData.requestedDate,
        firstName: this.usersCreationData.firstName,
        lastName: this.usersCreationData.lastName,
        userId: this.usersCreationData.userId,
        status: this.usersCreationData.status,
        systemRequiredBoolean: this.usersCreationData.systemRequiredBoolean,
        systemRequired: this.usersCreationData.systemRequired,
        biometric: this.usersCreationData.biometric,
        ismsTraining: this.usersCreationData.ismsTraining,
        ismsAgreement: this.usersCreationData.ismsAgreement,
        passwordBoolean: this.usersCreationData.passwordBoolean,
        domainUserId: this.usersCreationData.domainUserId,
        ndaSignedBoolean: this.usersCreationData.ndaSignedBoolean,
        ndaSignedDate: this.usersCreationData.ndaSignedDate,
        emailIdRequired: this.usersCreationData.emailIdRequired,
        remarks: this.userCreationForm.get('remarks').value,
        licenseType: this.userCreationForm.get('licenseType').value,
        licenseRequired: this.userCreationForm.get('licenseRequired').value,
        licenseAllocation: this.userCreationForm.get('licenseAllocation').value,
      }
      if (response) {
        this.userService.updateUserCreation(this.userCreationId, userCreationData).subscribe((response) => {
          this.backToOnboarding();
        })
      }
    })
  }

  get f() {
    return this.usersForm.controls;
  }

  openItonboarding() {
    this.router.navigate([this.tenantId + '/dashboard/itm/onboarding-it', {id: this.userCreationId}]);
  }

  openHrmonboarding() {
    this.router.navigate([this.tenantId + '/dashboard/itm/onboarding-form', {id: this.userCreationId}]);
  }

  openndaonboarding() {
    this.router.navigate([this.tenantId + '/dashboard/itm/onboarding-nda', {id: this.userCreationId}]);
  }

  backToOnboarding(){
    this.router.navigate([ this.tenantId + '/dashboard/itm/onboarding' ]);
  }

  // Pop-up message
  openSnackBar(message: string) {
    this.snackBar.open(message, 'Close', { duration: 3000 });
  }
 

  checkLicenseStatus(licenseStatusValue){
    let b : string = licenseStatusValue.split(': ')[1];
    if(b === 'true'){
      this.license = true;
    }
    else{
      this.license = false;
      this.userCreationForm.patchValue({
        licenseType: ''
      });
    }
  }

  notifyLicense(){
    let license = this.userCreationForm.get('licenseType').value;
    let userName = this.usersCreationData.firstName + " " + this.usersCreationData.lastName;
    this.userService.notifyLicense(license, userName).subscribe((response: any)=>{
      this.openSnackBar('Licence Notification Email is sent.');
    });
  }

}
